import React, { useState } from 'react';
import { ShieldCheck, CheckCircle, Download, MonitorSmartphone, Lock, ChevronDown, ChevronUp, Star, Droplets, TrendingUp } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface PurchaseSectionProps {
  id?: string;
  showFooter?: boolean;
}
export function PurchaseSection({
  id,
  showFooter = false
}: PurchaseSectionProps) {
  const [selectedOffer, setSelectedOffer] = useState<'upsell' | 'standard'>('upsell');
  const [showUpsellDetails1, setShowUpsellDetails1] = useState(false);
  const [showUpsellDetails2, setShowUpsellDetails2] = useState(false);
  const offers = {
    upsell: {
      title: 'Manual Académico + Capacitación Piscinas + MEGAPACK FÁBRICA RENTABLE™',
      price: '26.990',
      originalPrice: '99.990',
      checkoutUrl: 'https://checkout.ecompradigital.online/cart/46961015029948:1'
    },
    standard: {
      title: 'Solo Manual Académico de Fórmulas',
      price: '19.990',
      originalPrice: '79.990',
      checkoutUrl: 'https://checkout.ecompradigital.online/cart/46972435431612:1'
    }
  };
  const currentOffer = offers[selectedOffer];
  return <section id={id} className="py-6 md:py-12 px-4 bg-dark-800" data-id="element-117">
      <div className="max-w-xl mx-auto bg-dark-900 rounded-2xl shadow-xl border border-dark-700 overflow-hidden" data-id="element-118">
        {/* Header badge */}
        <div className="bg-brand-500 py-2 text-center" data-id="element-119">
          <h3 className="text-sm md:text-base font-black uppercase tracking-wider text-dark-900" data-id="element-120">
            🔥 OFERTA DE LANZAMIENTO
          </h3>
        </div>

        <div className="p-5 md:p-6" data-id="element-121">
          <p className="text-sm md:text-base text-brand-300 font-medium mb-6 text-center px-2" data-id="element-122">
            <span className="font-bold text-white" data-id="element-123">
              TODO el sistema para fabricar productos de limpieza
            </span>{' '}
            y comenzar tu emprendimiento desde cero.
          </p>

          {/* Offer Selection */}
          <div className="space-y-4 mb-6" data-id="element-124">
            {/* Upsell Option */}
            <div onClick={() => setSelectedOffer('upsell')} className={`relative cursor-pointer rounded-xl border-2 p-4 transition-all duration-200 ${selectedOffer === 'upsell' ? 'border-brand-400 bg-brand-500/10' : 'border-dark-700 bg-dark-800 hover:border-dark-600'}`} data-id="element-125">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-500 text-dark-900 text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-126">
                <Star size={12} fill="currentColor" data-id="element-127" /> MÁS ELEGIDA
              </div>
              <div className="flex items-center gap-3 mt-2" data-id="element-128">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOffer === 'upsell' ? 'border-brand-400' : 'border-gray-500'}`} data-id="element-129">
                  {selectedOffer === 'upsell' && <div className="w-2.5 h-2.5 bg-brand-400 rounded-full" data-id="element-130"></div>}
                </div>
                <div data-id="element-131">
                  <h4 className={`font-bold text-sm md:text-base leading-tight ${selectedOffer === 'upsell' ? 'text-white' : 'text-gray-300'}`} data-id="element-132">
                    Manual de Fórmulas + Capacitación Piscinas +{' '}
                    <span className="text-brand-400" data-id="element-133">
                      MEGAPACK FÁBRICA RENTABLE™
                    </span>
                  </h4>
                  <p className="text-xs text-gray-400 mt-1" data-id="element-134">
                    La experiencia completa para fabricar, vender y generar
                    ingresos con tu propia marca.
                  </p>
                </div>
              </div>

              {/* Upsell Details Toggles */}
              <div className="mt-4 pl-8 space-y-3" data-id="element-135">
                {/* Toggle 1 */}
                <div data-id="element-136">
                  <button onClick={e => {
                  e.stopPropagation();
                  setShowUpsellDetails1(!showUpsellDetails1);
                }} className="text-xs font-bold text-brand-400 flex items-center gap-1 hover:text-brand-300 transition-colors bg-dark-900/50 px-3 py-1.5 rounded-lg border border-dark-700 w-full justify-between" data-id="element-137">
                    ¿Qué incluye la Capacitación de Piscinas?
                    {showUpsellDetails1 ? <ChevronUp size={14} data-id="element-138" /> : <ChevronDown size={14} data-id="element-139" />}
                  </button>

                  {showUpsellDetails1 && <div className="mt-2 bg-dark-900 rounded-xl p-4 border border-brand-500/30 shadow-inner text-sm animate-popup" data-id="element-140">
                      <div className="flex items-center gap-2 mb-3" data-id="element-141">
                        <div className="bg-blue-500/20 p-1.5 rounded-md" data-id="element-142">
                          <Droplets size={18} className="text-blue-400" data-id="element-143" />
                        </div>
                        <h5 className="font-black text-white text-base" data-id="element-144">
                          CAPACITACIÓN DE PISCINAS
                        </h5>
                      </div>
                      <ul className="space-y-2 mb-3" data-id="element-145">
                        {['Recuperación de agua verde', 'Clarificación y filtrado', 'Algicidas y desinfectantes', 'Balance químico', 'Mantenimiento preventivo', 'Limpieza profesional', 'Cómo ofrecer este servicio a terceros'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-146">
                            <CheckCircle size={16} className="text-blue-400 shrink-0 mt-0.5" data-id="element-147" />
                            <span data-id="element-148">{item}</span>
                          </li>)}
                      </ul>
                      <p className="text-xs text-blue-300 font-bold italic" data-id="element-149">
                        Este bonus puede convertirse en una segunda fuente de
                        ingresos.
                      </p>
                    </div>}
                </div>

                {/* Toggle 2 */}
                <div data-id="element-150">
                  <button onClick={e => {
                  e.stopPropagation();
                  setShowUpsellDetails2(!showUpsellDetails2);
                }} className="text-xs font-bold text-brand-400 flex items-center gap-1 hover:text-brand-300 transition-colors bg-dark-900/50 px-3 py-1.5 rounded-lg border border-dark-700 w-full justify-between" data-id="element-151">
                    ¿Qué incluye el Megapack Fábrica Rentable™?
                    {showUpsellDetails2 ? <ChevronUp size={14} data-id="element-152" /> : <ChevronDown size={14} data-id="element-153" />}
                  </button>

                  {showUpsellDetails2 && <div className="mt-2 bg-dark-900 rounded-xl p-4 border border-brand-500/30 shadow-inner text-sm animate-popup" data-id="element-154">
                      <div className="flex items-center gap-2 mb-3" data-id="element-155">
                        <div className="bg-brand-500/20 p-1.5 rounded-md" data-id="element-156">
                          <TrendingUp size={18} className="text-brand-400" data-id="element-157" />
                        </div>
                        <h5 className="font-black text-white text-base" data-id="element-158">
                          MEGAPACK FÁBRICA RENTABLE™
                        </h5>
                      </div>
                      <p className="text-gray-300 font-medium mb-3 text-xs" data-id="element-159">
                        El sistema paso a paso para transformar las fórmulas en
                        un negocio real.
                      </p>
                      <ul className="space-y-2" data-id="element-160">
                        {['Cómo elegir los productos más rentables', 'Cómo calcular costos correctamente', 'Cómo fijar precios para ganar dinero', 'Cómo crear una marca propia', 'Cómo diseñar etiquetas atractivas', 'Cómo conseguir los primeros clientes', 'Cómo vender por redes sociales (WhatsApp, FB, IG)', 'Cómo organizar la producción', 'Cómo escalar tu emprendimiento'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-161">
                            <CheckCircle size={16} className="text-brand-400 shrink-0 mt-0.5" data-id="element-162" />
                            <span data-id="element-163">{item}</span>
                          </li>)}
                      </ul>
                    </div>}
                </div>
              </div>
            </div>

            {/* Standard Option */}
            <div onClick={() => setSelectedOffer('standard')} className={`cursor-pointer rounded-xl border-2 p-4 transition-all duration-200 ${selectedOffer === 'standard' ? 'border-brand-400 bg-brand-500/10' : 'border-dark-700 bg-dark-800 hover:border-dark-600'}`} data-id="element-164">
              <div className="flex items-center gap-3" data-id="element-165">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOffer === 'standard' ? 'border-brand-400' : 'border-gray-500'}`} data-id="element-166">
                  {selectedOffer === 'standard' && <div className="w-2.5 h-2.5 bg-brand-400 rounded-full" data-id="element-167"></div>}
                </div>
                <div data-id="element-168">
                  <h4 className={`font-bold text-sm md:text-base ${selectedOffer === 'standard' ? 'text-white' : 'text-gray-300'}`} data-id="element-169">
                    Solo Manual de Fórmulas
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {/* Price Display */}
          <div className="text-center mb-6 bg-dark-800 py-4 rounded-xl border border-dark-700" data-id="element-170">
            <p className="text-gray-500 font-bold line-through text-sm mb-1" data-id="element-171">
              ${currentOffer.originalPrice} ARS
            </p>
            <p className="text-4xl md:text-5xl font-black text-brand-400 leading-none mb-2" data-id="element-172">
              ${currentOffer.price}
              <span className="text-xl" data-id="element-173"> ARS</span>
            </p>
            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-174">
              Pago único • Acceso inmediato
            </p>
          </div>

          {/* Benefits row */}
          <div className="flex flex-wrap justify-center gap-x-3 gap-y-2 mb-6 text-xs font-semibold text-gray-300" data-id="element-175">
            <span className="flex items-center gap-1 bg-dark-800 px-2 py-1 rounded-md border border-dark-700" data-id="element-176">
              <Download className="text-brand-400" size={14} data-id="element-177" />
              Descarga inmediata
            </span>
            <span className="flex items-center gap-1 bg-dark-800 px-2 py-1 rounded-md border border-dark-700" data-id="element-178">
              <CheckCircle className="text-brand-400" size={14} data-id="element-179" />
              Acceso de por vida
            </span>
            <span className="flex items-center gap-1 bg-dark-800 px-2 py-1 rounded-md border border-dark-700" data-id="element-180">
              <MonitorSmartphone className="text-brand-400" size={14} data-id="element-181" />
              Celular y PC
            </span>
          </div>

          <div className="flex justify-center w-full" data-id="element-182">
            <CTAButton checkoutUrl={currentOffer.checkoutUrl} className="w-full md:w-auto text-base md:text-lg py-4 shadow-lg shadow-brand-500/20 text-dark-900" data-id="element-183" />
          </div>

          <div className="flex items-center justify-center gap-2 mt-4 text-xs font-medium text-[#93959C]" data-id="element-184">
            <Lock size={12} data-id="element-185" /> Pago 100% seguro
            <span className="mx-1" data-id="element-186">•</span>
            <ShieldCheck size={12} className="text-brand-400" data-id="element-187" /> Garantía 7 días
          </div>
        </div>
      </div>

      {showFooter && <div className="text-center mt-12 max-w-2xl mx-auto space-y-4 px-2" data-id="element-188">
          <h3 className="text-xl font-black text-white uppercase tracking-widest mb-4" data-id="element-189">
            ⏳ ESTA OFERTA NO SERÁ PARA SIEMPRE
          </h3>
          <div className="text-gray-400 font-medium text-base space-y-3" data-id="element-190">
            <p data-id="element-191">El precio actual corresponde al lanzamiento.</p>
            <p data-id="element-192">
              Continuaremos agregando nuevas fórmulas, nuevos recursos, nuevas
              capacitaciones y nuevas herramientas para emprendedores.
            </p>
            <p data-id="element-193">
              Y cuando eso ocurra...{' '}
              <span className="text-red-400 font-bold" data-id="element-194">
                El valor del acceso aumentará.
              </span>
            </p>
            <p className="text-gray-200 font-bold mt-4" data-id="element-195">
              Quienes ingresen hoy conservarán el precio actual y recibirán
              todas las futuras actualizaciones sin costo adicional.
            </p>
          </div>

          <div className="mt-12 bg-dark-900 border border-dark-700 rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-196">
            <ShieldCheck size={48} className="text-brand-400 mx-auto mb-4" data-id="element-197" />
            <h3 className="text-xl md:text-2xl font-black text-white uppercase mb-4" data-id="element-198">
              🛡 GARANTÍA TOTAL DE 7 DÍAS
            </h3>
            <p className="text-gray-300 mb-3" data-id="element-199">
              Probá todo el material durante 7 días.
            </p>
            <p className="text-gray-300 mb-3" data-id="element-200">
              Si considerás que no cumple con lo prometido, simplemente
              solicitás la devolución y te reintegramos el dinero.
            </p>
            <p className="text-brand-400 font-bold" data-id="element-201">
              Tu compra está completamente protegida.
            </p>
          </div>
        </div>}
    </section>;
}